<template>

    <iframe ref="docGenFrame" type="text/html" :src="url" width="100%" height="100%"
            style="overflow: auto; border: 1px ridge blue" @load="onFrameLoad">
    </iframe>

</template>

<script>
import api from "../api";

export default {
  data() {
    return {
      url: ""
    };
  },
  created() {
    console.log("Created")
    const urlParams = new URLSearchParams(window.location.search);
    const url = urlParams.get("url");

    this.url = /^https?:\/\//i.test(url) ? url : "https://" + url;
  },
  mounted() {
    this._auditMessageHandler = (event) => {
      if (!event.data || event.data.type !== 'lcs-audit') return;
      const { eventType, resourceType, resourceId, resourceDescription, category } = event.data;
      api.logAudit(eventType, resourceType, resourceId, resourceDescription, category);
    };
    window.addEventListener('message', this._auditMessageHandler);
  },
  beforeDestroy() {
    window.removeEventListener('message', this._auditMessageHandler);
  },
  methods: {
    onFrameLoad() {
      // Passes the current user's JWT into the embedded DocGen app so it can call
      // GatewayAPI's permission-gated endpoints instead of hitting its own API anonymously.
      const token = localStorage.getItem("api_Key");
      if (!token) return;

      const targetOrigin = new URL(this.url).origin;
      this.$refs.docGenFrame.contentWindow.postMessage({ type: 'lcs-auth', token }, targetOrigin);
    }
  }
}
</script>

<style scoped>

</style>
